import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Benefits from "../components/Benefits";
import VideoDemo from "../components/VideoDemo";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import CTASection from "../components/CTASection";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { Toaster } from "../components/ui/sonner";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-slate-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <Benefits />
        <VideoDemo />
        <Pricing />
        <FAQ />
        <CTASection />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default LandingPage;
